import logoBlackNegative from '../../assets/images/logoBlackNegative.png';
import logoBlackPositive from '../../assets/images/logoBlackPositive.png';
import logoWhiteNegative from '../../assets/images/logoWhiteNegative.png';
import logoWhitePositive from '../../assets/images/logoWhitePositive.svg';

interface Props {
  type?: 'logoBlackNegative' | 'logoBlackPositive' | 'logoWhiteNegative' | 'logoWhitePositive';
  showText?: boolean;
}

const logos = {
  logoBlackNegative,
  logoBlackPositive,
  logoWhiteNegative,
  logoWhitePositive,
};

const Logo = (props: Props) => {
  const { type = 'logoWhitePositive' } = props;
  return (
    <div className="flex items-center">
      <img src={logos[type]} alt="" className="mr-[7px]" />
    </div>
  );
};

/* ["default", "primary", "ghost", "dashed", "link", "text"] */

export default Logo;
